import { z } from "zod"

export const Features = [
  "notifications",
  // If we're going to fetch all products via postback
  "fetch_all_products",
  // If we're going to use the new etl
  "etl_v2",
  // If we're etling data to the customer
  "etl",
  "paywall_preview_gallery",
  // Bogus feature to play with
  "bogus_feature",
  // Event properties v2 query
  "event_properties_v2",
  // Surveys
  "surveys",
  // Variant optimization
  "variant_optimization",
  // localization integrations
  "localization_integrations",
  // localization v4 for the v4 editor
  "localization_v3",
  // projects -- allow the linking of multiple applications together
  "projects",
  // allow creating editor v4 paywalls
  "editor_v4",
  // Web archive
  "manifest_cache",
  // bunny cdn
  "bunny_cdn",
  // Allow multiple paywall urls
  "enable_multiple_paywall_urls",
  // User page v2
  "user_page_v2",
  // Localization upload & download
  "localization_upload_download",
  // Localization v4
  "localization_v4",
  // "asa_client",
  "asa_client",
  // "ass_client"
  "ass_client",
  // "asc_client"
  "asc_client",
  // "rule entitlements"
  "rule_entitlements",
  // "save_snapshot_and_promote"
  "save_snapshot_and_promote",
  "consumption_request",

  // Web v2 app
  "web_2_app",

  // App 2 Web
  "app_2_web",

  // Paddle
  "paddle",

  // Affiliate program callout (dashboard sidebar)
  "affiliate_program_callout",

  // AI campaign builder
  "ai_campaign_rules",

  // Audience templates
  "audience_templates",

  // Advanced rule editor
  "advanced_rule_editor",

  // Simple localization
  "editor_simple_localization",

  // CEL ensure key exists
  "cel_ensure_key_exists",

  // Svix webhook management
  "svix_webhooks",
] as const

export const PublicBetaFeatures = ["web_2_app"] as const

// These are here just so that we can remove all of them from
// the featuresEnabled lists in the Applications table.
export const LegacyFeatureFlags = ["triggers"]

export const DefaultFeatures = ["fetch_all_products", "surveys"] as const

export const FeatureSchema = z.enum(Features)
export const PublicBetaFeatureSchema = z.enum(PublicBetaFeatures)
export type Feature = (typeof Features)[number]

export const enabled = (feature: Feature, application?: { featuresEnabled: string[] }) => {
  return application && application.featuresEnabled.includes(feature)
}
